import { Destructor } from '@deqo/foundation';
import { Component } from './Component';
import { ComponentType } from './Interfaces';

export type InterceptorInstaller = (filter: Interceptor) => Destructor;

export type InterceptorCallback<T = Component> = (object: T, value: any) => any;

export interface Interceptor {
    id: string;
    type: string;
    property: string;
    get?: InterceptorCallback<Component>;
    set?: InterceptorCallback<Component>;
}

export type InterceptorCallbacks = Pick<Interceptor, 'get' | 'set'>;

export interface InterceptorBuilderDefineApply<T extends Component> {
    on(property: keyof T, callbacks: InterceptorCallbacks): Destructor;
}

export interface InterceptorBuilderInitial {
    for<T extends Component>(type: ComponentType<T>): InterceptorBuilderDefineApply<T>;
    forAllTypes(): InterceptorBuilderDefineApply<any>;
}

export class InterceptorBuilder implements
    InterceptorBuilderInitial,
    InterceptorBuilderDefineApply<any> {

    private config: Partial<Interceptor>;
    private install: InterceptorInstaller;

    constructor(id: string, install: InterceptorInstaller) {
        this.config = { id };
        this.install = install;
    }

    public for(type: any): any {
        const { name } = Component.describe(type);
        this.config.type = name;
        return this;
    }

    public forAllTypes(): any {
        this.config.type = '*';
        return this;
    }

    public on(property: any, callbacks: InterceptorCallbacks): Destructor {
        this.config.property = property;
        this.config.get = callbacks.get;
        this.config.set = callbacks.set;
        return this.install(this.config as Interceptor);
    }
}

